module.exports = __webpack_public_path__ + "img/th.c07f8010.svg";